class BESSAppMenuContact extends BESSAppComponent {

    constructor() {
        super('.app-nav-app-contact');
        this.contactModal = new BESSAppContactModal();
    }

    setupComponent(node) {
        node.bindClickEvent(this, () => this.contactModal.open());
    }
}